import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HeartPulse } from "lucide-react";
import { useT } from "@/lib/i18n";
import { api } from "@/lib/api";
import { formatDate } from "@/lib/format";
import { driverName, medicalStatus, MEDICAL_STYLES } from "@/lib/drivers";

export const MedicalAlert = () => {
  const { t, lang } = useT();
  const [list, setList] = useState([]);

  useEffect(() => {
    api.get("/drivers").then((r) => {
      const due = r.data
        .map((d) => ({ ...d, status: medicalStatus(d.medical_expiry) }))
        .filter((d) => d.status === "expired" || d.status === "expiring")
        .sort((a, b) => a.medical_expiry.localeCompare(b.medical_expiry));
      setList(due);
    }).catch(() => {});
  }, []);

  if (!list.length) return null;
  return (
    <div data-testid="medical-alert" className="mb-6 border border-[#FF3B30]/40 bg-[#FF3B30]/5 rounded-sm p-4 flex gap-3">
      <HeartPulse className="w-5 h-5 text-[#FF3B30] shrink-0 mt-0.5" />
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-baseline gap-x-3">
          <span className="font-heading uppercase font-bold text-[#FF3B30]">{t("medical_alert_title")}</span>
          <Link to="/drivers" data-testid="medical-alert-link" className="font-mono text-xs text-slate-400 hover:text-white underline-offset-2 hover:underline">{t("drivers_title")} →</Link>
        </div>
        <div className="flex flex-wrap gap-2 mt-2">
          {list.map((d) => (
            <span key={d.id} data-testid={`medical-alert-${d.id}`} className={`border rounded-sm px-2 py-1 font-mono text-xs ${MEDICAL_STYLES[d.status]}`}>
              <b>{driverName(d)}</b> · {t(`medical_${d.status}`)} {formatDate(d.medical_expiry, lang)}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
